import pica from 'pica/dist/pica';
import fixOrientation from './fix-orientation';

const MAX_WIDTH = 1920;
const MAX_HEIGHT = MAX_WIDTH * 4;
const OPTIONS = {
  alpha: true,
  quality: 3,
};

export default function resizeImage(file, maxWidth = MAX_WIDTH, maxHeight = MAX_HEIGHT) {
  const canvas = document.createElement('canvas');
  const img = document.createElement('img');
  const reader = new FileReader();
  let resolveFn;

  reader.onload = event =>
    fixOrientation(event.target.result, fixed => {
      img.src = fixed;
    });

  img.onload = () => {
    let width = img.width;
    let height = img.height;

    if (width > height && width > maxWidth) {
      height = Math.round(height * maxWidth / width);
      width = maxWidth;
    } else if (height > maxHeight) {
      width = Math.round(width * maxHeight / height);
      height = maxHeight;
    }

    canvas.width = width;
    canvas.height = height;

    pica.resizeCanvas(img, canvas, OPTIONS, () => {
      resolveFn({
        dataUrl: canvas.toDataURL(file.type),
        width,
        height,
      });
    });
  };

  reader.readAsDataURL(file);

  return new Promise(resolve => {
    resolveFn = resolve;
  });
}

export const readImage = file =>
  new Promise(resolve => {
    const reader = new FileReader();

    reader.onload = event => resolve(event.target.result);
    reader.readAsDataURL(file);
  });



// WEBPACK FOOTER //
// ./app/services/resize-image.js